import Keycloak from "keycloak-js";

const kc = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

let initialized: Promise<boolean> | null = null;

export function initKeycloak(): Promise<boolean> {
  if (!initialized) {
    initialized = kc.init({
      onLoad: "check-sso",
      silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
      pkceMethod: "S256",
    });
  }
  return initialized;
}

export function login(): void {
  kc.login({ redirectUri: window.location.href });
}

export function logout(): void {
  kc.logout({ redirectUri: window.location.origin });
}

export function token(): string | undefined {
  return kc.token;
}

export function authenticated(): boolean {
  return !!kc.authenticated;
}

export function profile() {
  return kc.tokenParsed as
    | { email?: string; name?: string; preferred_username?: string }
    | undefined;
}
